(function () {
  'use strict';

  angular.module('app').component('systemMaintenancePage', systemMaintenanceComponent());

  function systemMaintenanceComponent() {
    return {
      bindings: {},
      controller: function () {},
      controllerAs: 'vm',
      templateUrl: './app/ajs/admin/system-maintenance/system-maintenance-page.component.html',
    };
  }
})();
